export const SURVEY_KEYS = {
  JOB_ROLE: 'jobRole',
  JOB_FIELD: 'jobField',
  HUB_INTEREST: 'hubInterest',
  CRM_EXPERIENCE: 'crmExperience'
};
export const EXPERIENCE_NONE_PARAM = 'none';
export const EXPERIENCE_HAS_USED_CRM_PARAM = 'has_used_crm';
export const EXPERIENCE_HAS_USED_HUBSPOT = 'has_used_hubspot';
export const SALES_REP_ROLE = 'sales-rep';
export const SALES = 'sales';
export const MARKETING = 'marketing';
export const SERVICES_SUPPORT = 'services-support';
export const OTHER = 'other';
export const SALES_HUB_INTEREST = 'sales';
export const MARKETING_HUB_INTEREST = 'marketing';
export const CUSTOMER_SERVICE_HUB_INTEREST = 'customer-service';
export const CMS_HUB_INTEREST = 'cms';
export const CMS_SIGNUP_BUSINESS_INTENT = 'business';
export const FALSEY_SURVEY_VALUE = [undefined, null, ''];